import {Component, OnInit} from '@angular/core';
import {YOPA_USER_IMPERSONATE} from '../../constants/local-storage-keys.constansts';
import {UserService} from '../../services/user/user.service';
import {CurrentUserDetailsModel} from '../../../shared/models/users/users.models';

declare interface LegacySuperAdminDetails {
  name: string;
}

@Component({
  selector: 'app-default',
  templateUrl: './app-default.component.html',
  styleUrls: ['./app-default.component.scss']
})
export class AppDefaultComponent implements OnInit {

  public sidebarStatus: boolean;

  get currentSuperAdmin(): LegacySuperAdminDetails | null {
    try {
      return JSON.parse(JSON.parse(localStorage.getItem(YOPA_USER_IMPERSONATE))) as LegacySuperAdminDetails;
    } catch (error) {
      return null;
    }
  }

  get loggedInUser(): CurrentUserDetailsModel | undefined {
    return this.user.getDetailsFromStorage();
  }

  constructor(private user: UserService) {
  }

  ngOnInit(): void {
  }

  /**
   * Sets provided status to sidebarStatus variable
   * @param status: boolean
   */
  public setSidebarStatus(status: boolean): void {
    this.sidebarStatus = status;
  }

}
